import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext.tsx';
import saccoWithdrawalService from "@saccoWithdrawalService";

const QUERY_KEY = 'sacco_withdrawals';

export function useFetchSaccoWithdrawals(membershipId: string) {
  const { user } = useAuth();
  return useQuery({
    queryKey: [QUERY_KEY, membershipId],
    queryFn: async () => {
      return await saccoWithdrawalService.fetchAll(user!.id, membershipId);
    },
    enabled: !!user && !!membershipId,
  });
}

/**
 * @deprecated use useCreateSaccoWithdrawalWithCredit instead
 */
export function useCreateSaccoWithdrawal(membershipId: string) {
  const qc = useQueryClient();
  const { user } = useAuth();
  return useMutation({
    mutationFn: async (request: SaccoWithdrawalCreateRequest) => {
      return await saccoWithdrawalService.create(user!.id, membershipId, request);
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: [QUERY_KEY, membershipId] }),
  });
}

export function useUpdateSaccoWithdrawal(membershipId: string) {
  const qc = useQueryClient();
  const { user } = useAuth();
  return useMutation({
    mutationFn: async (request: SaccoWithdrawalUpdateRequest) => {
      return await saccoWithdrawalService.update(user!.id, request)
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: [QUERY_KEY, membershipId] });
      qc.invalidateQueries({ queryKey: ['transactions'] });
      qc.invalidateQueries({ queryKey: ['accounts'] });
    },
  });
}

export function useDeleteSaccoWithdrawal(membershipId: string) {
  const qc = useQueryClient();
  const { user } = useAuth();
  return useMutation({
    mutationFn: async (id: string) => {
      return await saccoWithdrawalService.delete(id, user!.id);
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: [QUERY_KEY, membershipId] });
      qc.invalidateQueries({ queryKey: ['transactions'] });
      qc.invalidateQueries({ queryKey: ['accounts'] });
    },
  });
}
